import React from 'react';

interface Props {}
export default class EditorBox extends React.PureComponent<Props> {
    render() {
        const { children } = this.props;

        return <div className="ct-editor-box">{children}</div>;
    }
}
